export default __webpack_public_path__ + "static/media/house-6.01fc50b9.jpg";